"use client";

import styles from "@/styles/product-detail/customer-reviews.module.scss";
import Image from "next/image";
import Link from "next/link";
import { Rate, ImagePreview } from "react-vant";
import { Arrow } from "@react-vant/icons";
import { useState, useEffect } from "react";
import productApi from "@/service/modules/productApi";

interface Props {
  productId: number | string;
}
export default function ProductCustomerReviews({ productId }: Props) {
  const defaultCustomerData = {
    review: [],
    reviewAvgRank: 0,
    reviewCount: 0,
    reviewSummary: {
      rating1: 0,
      rating2: 0,
      rating3: 0,
      rating4: 0,
      rating5: 0,
    },
    chartValue: {},
    totalPages: 0,
  };

  const [customerData, setCustomerData]: any = useState(defaultCustomerData);

  useEffect(() => {
    getReviews();
  }, []);

  const getReviews = async () => {
    try {
      const res = await productApi.getCustomerReviews({
        productID: productId,
        sort: "",
        start: 1,
        rows: 3,
      });
      if (res.data) {
        const newData = res.data;
        setCustomerData(newData);
      }
    } catch {
      console.log("fetch customer reviews error");
    }
  };

  return (
    <>
      {customerData && customerData.reviewCount ? (
        <div className={styles["comp-customer-reviews"]}>
          <div className={styles["content"]}>
            <div className={styles["title-box"]}>
              <div className={styles["title"]}>Ratings & Reviews</div>

              <div className={styles["rank-box"]}>
                <Rate
                  value={customerData.reviewAvgRank}
                  count={5}
                  voidColor={"#dedede"}
                  allowHalf
                  readOnly
                />
                <Link 
                  href={`${process.env.API_DOMAIN}/product/${productId}/reviews/`}
                  className={styles["product-rate-count"]}
                >
                  ({customerData.reviewCount})
                </Link>
              </div>
            </div>

            <div className={styles["chart-box"]}>
              <div className={styles["chart"]}>
                {[5, 4, 3, 2, 1].map((index: number) => {
                  function calculateParcent(num: number) {
                    const value =
                      Math.round((num / customerData.reviewCount) * 10000) /
                        100 || "0";
                    const parcent = Number(value) > 100 ? "100%" : value + "%";
                    return parcent;
                  }
                  const num = customerData.reviewSummary[`rating${index}`];
                  const parcent = calculateParcent(num);
                  return (
                    <div className={styles["reviews-item"]} key={index}>
                      <span className={styles["rate"]}>{index}</span>
                      <div className={styles["line"]}>
                        <div
                          className={styles["value"]}
                          style={{ width: parcent }}
                        ></div>
                      </div>
                      <span className={styles["percent"]}>{num}</span>
                    </div>
                  );
                })}
              </div>

              <Link href={`/review/index/pid/${productId}`}>
                <div className={styles["view-more"]}>
                  <Arrow fontSize={20}></Arrow>
                </div>
              </Link>
            </div>

            {customerData && customerData.review ? (
              <>
                <div className={styles["reviews-list"]}>
                  {customerData.review.map((item: any, index: number) => {
                    if (!item.detail) {
                      return null;
                    }
                    return (
                      <div className={styles["reviews-item"]} key={index}>
                        <div className={styles["user-info"]}>
                          <Image
                            className={styles["head-image"]}
                            src={`${process.env.IMAGE_DOMAIN}/svg/product-detail/model-photos.svg`}
                            alt="head-image"
                            width={40}
                            height={40}
                          />

                          <div>
                            <div className={styles["user-name"]}>
                              {item.customerName || "customer"}
                            </div>
                            <Rate
                              value={item.rate}
                              count={5}
                              color={"#FDC92E"}
                              voidColor={"#dedede"}
                              allowHalf
                              readOnly
                              size={16}
                            />
                          </div>

                          <div className={styles["review-time"]}>
                            {item.createTime}
                          </div>
                        </div>

                        <div className={styles["content"]}>
                          {item.detail}
                          {!!(item.imgArray && item.imgArray.length > 0) && (
                            <div className={styles["img-list"]}>
                              {item.imgArray.map((img: string) => (
                                <div
                                  className={styles["comment-img"]}
                                  key={img}
                                >
                                  <Image
                                    src={img}
                                    width={100}
                                    height={100}
                                    alt={img}
                                    onClick={() =>
                                      ImagePreview.open({
                                        images: item.imgArray,
                                        onChange: (index) =>
                                          console.log(
                                            `当前展示第${index + 1}张`
                                          ),
                                      })
                                    }
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <Link
                  href={`/review/index/pid/${productId}`}
                  className={styles["view-all"]}
                >
                  View All Reviews{" "}
                  <Arrow
                    style={{ marginTop: "2px", marginLeft: "4px" }}
                  ></Arrow>
                </Link>
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
}
